import { HtmlEntities } from '../constants/html-entities'

/**
 * Returns the formatted display name of the given address, which is the concatenation of all available names.
 *
 * @param {Address} address - the address object.
 * @returns {string} the formatted display name
 */
export function formatAddressName(address, showNumber = false) {
    return (
        address.name1 +
        (address.name2 || address.name3 ? ` ${HtmlEntities.NDASH}` : '') +
        (address.name2 ? ` ${address.name2}` : '') +
        (address.name3 ? ` ${address.name3}` : '') +
        (showNumber && address.number ? ` (${address.number})` : '')
    )
}
